<template>
  <div class="rate-inspector">
    <h1 class="test-inspector-survey">INSPECTOR SURVEY</h1>
    <hr />

    <div v-if="loading" class="rate-inspector--loading">
      <p>Retrieving your Inspector</p>
    </div>

    <div v-else-if="inspector" class="rate-inspector--content">
      <vue-headful :title="`Rate ${inspectorFullName}`" />

      <Alert
        v-if="showRatedMessage"
        class="test-already-rated"
        type="info"
        @close="showRatedMessage = false">
        You have already rated {{inspectorFullName}}. Only one rating is allowed per inspector.
      </Alert>

      <InspectorRating v-if="hasRating" :inspector="inspector" :rating="rating" />

      <Alert v-if="showApiError" type="error" @close="showApiError = false">
        <div v-for="(errorMessage, index) in apiErrors" :key="index">
          {{errorMessage}}
        </div>
      </Alert>

      <hg-rate-inspector-form
        v-if="showForm"
        :inspectorId="inspectorId"
        :inspectorName="inspectorFullName"
        :hg-show-confirmation="showConfirmation"
        @submitRating="submitRating" />
    </div>

    <div v-else>
      <vue-headful title="Unable to find Inspector" />
      <Alert type="error">
        Sorry, we couldn't find that Inspector.
      </Alert>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Alert from '@/components/Shared/Alert.vue';
import InspectorRating from '../RateInspector/InspectorRating.vue';
import RateInspectorForm from '../RateInspector/RateInspectorForm.vue';

export default {
  data() {
    return {
      hasRating: false,
      loading: false,
      inspector: {},
      showRatedMessage: false,
      showForm: false,
      showConfirmation: false,
      apiErrors: [],
      showApiError: false,
    };
  },
  async mounted() {
    await this.retrieveInspector(this.$route.params.inspectorId);
    if (this.inspector) {
      await this.isRated();
    }
  },
  components: {
    InspectorRating,
    Alert,
    'hg-rate-inspector-form': RateInspectorForm,
  },
  computed: {
    ...mapState('Inspectors', {
      rating: state => state.rating,
    }),
    ...mapState('User', {
      currentUser: state => state.currentUser,
    }),
    inspectorId() {
      return this.inspector
        ? this.inspector.id || this.inspector.legacyId
        : null;
    },
    inspectorFullName() {
      return this.inspector
        ? `${this.inspector.givenName} ${this.inspector.familyName}`
        : '';
    },
  },
  methods: {
    redirectSuccess(inspectorName) {
      this.$router.push({
        name: 'myInspectors',
        params: {
          ratedInspector: inspectorName,
          ratedSuccess: true,
        },
      });
    },
    async retrieveInspector() {
      this.loading = true;
      try {
        this.inspector = await this.$store.dispatch('Inspectors/getInspectorById', this.$route.params.inspectorId);
      } catch (e) {
        this.inspector = null;
      }
      this.loading = false;
    },
    async submitRating(rating) {
      this.showApiError = false;
      await this.isRated();
      if (!this.rating.customerId) {
        try {
          await this.$store.dispatch('Inspectors/addRating', rating);
          this.redirectSuccess(this.inspectorFullName);
        } catch (e) {
          this.setApiError(e.data.error);
        }
      }
    },
    async isRated() {
      await this.$store.dispatch('Inspectors/loadRating', {
        inspectorId: this.$route.params.inspectorId,
        customerId: this.currentUser.legacyId,
      });

      this.displayForm(!this.rating.customerId);
    },
    displayForm(state) {
      this.hasRating = !state;
      this.showRatedMessage = !state;
      this.showForm = state;
    },
    setApiError(errors) {
      this.apiErrors = (errors && errors.constraintViolations)
        ? errors.constraintViolations.comment
        : ['There was an error while rating your inspector'];
      this.showApiError = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/theme';

hr {
  border: solid 2px $theme-color-primary;
  margin-bottom: 20px;
  margin-top: 20px;
  width: 100%;
}

.rate-inspector {
  padding: 30px;
}

.thank-you {
  text-align: center;
}


@media all and (min-width: 655px) {
  hr {
    margin-bottom: 50px;
    margin-top: 40px;
  }

  .rate-inspector {
    padding: 50px;
  }
}
</style>
